<template>
  <v-data-table
    v-model="selected"
    class="elevation-2"
    :headers="headers"
    :items="invoices"
    :search="$store.state.searchList"
    show-select
    :options.sync="$store.state.optionsList"
    :header-props="headerOptions"
    :footer-props="footerOptions"
  >
    <template v-slot:item.viewDate="props">
      {{ props.item.viewDate | toLocaleDate($i18n.locale) }}
    </template>
    <template v-slot:item.actions="props">
      <v-btn
        icon
        color="transparent"
        @click="$store.dispatch('showInvoice', props.item.id)"
      >
        <v-icon color="primary">
          far fa-eye
        </v-icon>
      </v-btn>
      <v-btn
        v-if="!$mobileDetect.tablet()"
        color="transparent"
        icon
        @click="$store.dispatch('downloadInvoices', [props.item.id])"
      >
        <v-icon color="primary">
          far fa-arrow-alt-circle-down
        </v-icon>
      </v-btn>
    </template>
    <template v-slot:item.recapActions="props">
      <v-btn
        v-if="displayBtnRecap(props.item.name)"
        icon
        color="transparent"
        @click="$store.dispatch('showRecap', props.item.id)"
      >
        <v-icon color="primary">
          far fa-id-card
        </v-icon>
      </v-btn>
    </template>
    <template v-slot:body.append>
      <tr>
        <td
          colspan="6"
          class="text-center"
        >
          {{ $t('home.periodPreserving') }}
        </td>
      </tr>
    </template>
    <template v-slot:no-data>
      {{ $t('home.noInvoices') }}
    </template>
  </v-data-table>
</template>
<script>
  export default {
    name: 'DatatableView',
    filters: {
      toLocaleDate (value, locale) {
        const options = { year: 'numeric', month: 'long', day: 'numeric' }
        const date = new Date(value)
        return date.toLocaleDateString(locale, options)
      },
    },
    data () {
      return {
        isModalVisible: false,
        headerOptions: {
          sortIcon: 'fas fa-arrow-up',
        },
        headers: [
          { text: this.$t('home.account'), align: 'left', value: 'customer.id' },
          { text: this.$t('home.name'), align: 'left', value: 'name' },
          { text: this.$t('home.date'), align: 'left', value: 'viewDate' },
          { text: this.$t('home.factures'), sortable: false, align: 'center', value: 'actions' },
          { text: this.$t('home.recap'), sortable: false, align: 'center', value: 'recapActions' },
        ],
        footerOptions: {
          itemsPerPageOptions: [3, 6, 9, 12, -1],
          itemsPerPageAllText: this.$t('home.all'),
          itemsPerPageText: this.$t('home.itemsPerPage'),
        },
      }
    },
    computed: {
      selected: {
        get () {
          return this.$store.state.invoices.selected
        },
        set (value) {
          this.$store.commit('SET_SELECTED_INVOICES', value)
        },
      },
      invoices () {
        return this.$store.state.invoices.filtered
      },
    },
    methods: {
      displayBtnRecap: function (name) {
        const dateExtPdf = name.split('_')[3]
        const createdDate = dateExtPdf.split('.')[0]
        var year = createdDate.substring(0, 4)
        var month = createdDate.substring(4, 6)
        var day = createdDate.substring(6, 8)
        const date = `${year}-${month}-${day}`
        return date > '2021-11-01'
      },
    },
  }
</script>
